import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import SuccessModal from "../../SuccessModal";
import { customerAddressCreate } from "../../../services/CustomerInfo/EditCustomer";
import { getBrandSearchLocality } from "../../../services/Locality/Locality";
import { InputSwitch } from "primereact/inputswitch";

export default function CreateCustomerAddressModal({
  setCreateCustomerAddressModalVisible,
  createCustomerAddressModalVisible,
  editCustomerData,
  storeCustomerId,
  sendDataToEditCustomer,
  brandId,
  enabledLocality,
}) {
  const [editAddressLineValue1, setEditAddressLineValue1] = useState("");
  const [editAddressLineValue2, setEditAddressLineValue2] = useState("");
  const [editAddressCityValue, setEditAddressCityValue] = useState("");
  const [editAddressStateValue, setEditAddressStateValue] = useState("");
  const [editAddressLandmarkValue, setEditAddressLandmarkValue] = useState("");
  const [editAddressPinValue, setEditAddressPinValue] = useState("");
  const [selectedSearchItem, setSelectedSearchItem] = useState(null); // Track selected item

  const handleAddressLineOneEditChange = (text) => {
    const copyText = text.replace(/[^A-Za-z0-9\-, ]/g, "");
    setEditAddressLineValue1(copyText);
  };
  const handleAddressLineTwoEditChange = (text) => {
    const copyText = text.replace(/[^A-Za-z0-9\-, ]/g, "");
    setEditAddressLineValue2(copyText);
  };
  const handleAddressCityEditChange = (text) => {
    const copyText = text.replace(/[^A-Za-z0-9\-, ]/g, "");
    setEditAddressCityValue(copyText);
  };
  const handleAddressStateEditChange = (text) => {
    const copyText = text.replace(/[^A-Za-z0-9\-, ]/g, "");
    setEditAddressStateValue(copyText);
  };
  const handleAddressLandmarkEditChange = (text) => {
    const copyText = text.replace(/[^A-Za-z0-9\-, ]/g, "");
    setEditAddressLandmarkValue(copyText);
  };
  const handleAddressPinEditChange = (text) => {
    setEditAddressPinValue(text);
  };

  const [activeNotification, setActiveNotification] = useState(false);

  const [loading, setLoading] = useState(false);
  const [localityInfoData, setLocalityInfoData] = useState([]);

  const fetchBrandSearchLocality = (data) => {
    getBrandSearchLocality(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setLocalityInfoData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchLocality = (text) => {
    setSearchTerm(text);
    handleSearch(text);
  };

  const handleSearch = async (text) => {
    if (text) {
      const data = {
        brandId: brandId,
        locality: text,
        city: "",
        state: "",
        pin: "",
      };
      fetchBrandSearchLocality(data);
      setLoading(true);
    } else {
      setLoading(false);
    }
  };

  const [errors, setErrors] = useState({
    editAddressLineValue1: "",
    editAddressPinValue: "",
  });

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    if (editAddressLineValue1 === "") {
      newErrors.editAddressLineValue1 = "Please Fill Address Line 1";
      isValid = false;
    } else {
      newErrors.editAddressLineValue1 = "";
    }
    if (editAddressPinValue === "") {
      newErrors.editAddressPinValue = "Please Enter Pin Code";
      isValid = false;
    } else {
      newErrors.editAddressPinValue = "";
    }
    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const storeId = editCustomerData?.storeId;
  const handleEditData = async () => {
    // Update the specific field in addressItems
    if (validateForm()) {
      let updatedData = {
        addressLine1: editAddressLineValue1,
        addressLine2: editAddressLineValue2,
        city: editAddressCityValue,
        contactNo: "",
        landmark: editAddressLandmarkValue,
        state: editAddressStateValue,
        pin: editAddressPinValue,
        isDefault: activeNotification, // Include the 'isDefault' field
        // currentLocation
        // latitude
        // longitude
      };
      // Add more conditions for other fields

      try {
        const response = await customerAddressCreate(
          storeCustomerId,
          storeId,
          updatedData
        );
        if (!response.data.error) {
          const Res = response.data;
          const message = Res.message;
          const status = Res.status;

          // Close the modal
          setEditAddressLineValue1("");
          setEditAddressLineValue2("");
          setEditAddressCityValue("");
          setEditAddressStateValue("");
          setEditAddressLandmarkValue("");
          setEditAddressPinValue("");
          setSearchTerm("");
          handleSearch("");
          setErrors({
            ...errors,
            editAddressLineValue1: "",
            editAddressPinValue: "",
          });
          setCreateCustomerAddressModalVisible(false);
          sendDataToEditCustomer({
            success: true,
          });
          if (status === true) {
            setModalVisible(true);
            setModalStatus("success");
            setModalText(message);
          } else {
            setModalVisible(true);
            setModalStatus("not Success");
            setModalText(message);
          }
          // if (Res) {
          //   sendDataToEditCustomer({
          //     success: true,
          //   });
          // }
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const handleItemPressSearchedLocality = (item) => {
    setSelectedSearchItem(item);
    setLoading(false);
    setLocalityInfoData([]);
    setSearchTerm("");
    setEditAddressLineValue2(item?.locality);
    setEditAddressCityValue(item?.city);
    setEditAddressStateValue(item?.state);
    setEditAddressLandmarkValue(item?.landmark);
    setEditAddressPinValue(item?.pin);
  };

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const handleModalClose = () => {
    setCreateCustomerAddressModalVisible(false);
    setSelectedSearchItem('');
    setLoading(false);
    setLocalityInfoData([]);
    setSearchTerm("");
    setEditAddressLineValue2("");
    setEditAddressCityValue("");
    setEditAddressStateValue("");
    setEditAddressLandmarkValue("");
    setEditAddressPinValue("");
  };

  const renderLocalityData = () => {
    return localityInfoData?.map((item, index) => (
      <div
        style={{
         padding:3,
          borderBottomWidth: 1,
          borderBottomColor: '#D2DBD6',
        }}
      >
        <div
          onClick={() => handleItemPressSearchedLocality(item)}
          style={{ cursor: "pointer" }}
        >
          <div>
            <p>
              {item?.locality}, {item?.city}, {item?.pin}
            </p>

            {selectedSearchItem === item && (
              <div>
                <i
                  className="pi pi-check"
                  style={{ fontSize: "25px", marginLeft: 10, color: "#008EFF" }}
                ></i>
              </div>
            )}
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={createCustomerAddressModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!createCustomerAddressModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <i
                className="pi pi-map-marker"
                style={{ fontSize: "30px", color: "#fff" }}
              ></i>
              <p className=" text-4xl text-primary-50 font-semibold">
                Create Address
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            <div
              className="h-25rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              {enabledLocality && (
                <div style={{ marginTop: 5, marginBottom: 5 }} className="mx-4">
                  <div>
                    <div>
                      <p>Search Locality</p>
                      <InputText
                        value={searchTerm}
                        onChange={(e) => handleSearchLocality(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              )}

              {loading && localityInfoData.length > 0 ? (
                <div className="mx-4">
                  <div>
                    <p>Please Select Locality</p>
                  </div>
                  <div
                    className="h-15rem scroll-bar mb-2"
                    style={{
                      overflowY: "scroll",
                      borderRadius: 15,
                      backgroundColor: "#eaf6f6",
                      padding:10
                    }}
                  >
                    {renderLocalityData()}
                  </div>
                </div>
              ) : (
                <>
                  {enabledLocality && (
                    <div
                      style={{ marginTop: 1, marginBottom: 1 }}
                      className="mx-4"
                    >
                      <p>Or</p>
                    </div>
                  )}

                  <div className="flex flex-column mx-4 my-2">
                    <InputText
                      value={editAddressLineValue1}
                      onChange={(e) =>
                        handleAddressLineOneEditChange(e.target.value)
                      }
                      id="firstName"
                      label="firstName"
                      placeholder="Address Line 1"
                      className="w-full  bg-white-alpha-20 border-round-lg p-2 text-lg "
                    ></InputText>
                  </div>

                  {errors.editAddressLineValue1 && (
                    <div>
                      <p>{errors.editAddressLineValue1}</p>
                    </div>
                  )}

                  <div className="flex flex-column mx-4 my-2">
                    <InputText
                      value={editAddressLineValue2}
                      onChange={(e) =>
                        handleAddressLineTwoEditChange(e.target.value)
                      }
                      id="firstName"
                      label="firstName"
                      placeholder="Address Line 2"
                      className="w-full  bg-white-alpha-20 border-round-lg p-2 text-lg "
                    ></InputText>
                  </div>

                  <div className="flex flex-column mx-4 my-2">
                    <InputText
                      value={editAddressCityValue}
                      onChange={(e) =>
                        handleAddressCityEditChange(e.target.value)
                      }
                      id="firstName"
                      label="firstName"
                      placeholder="City"
                      className="w-full  bg-white-alpha-20 border-round-lg p-2 text-lg "
                    ></InputText>
                  </div>

                  <div className="flex flex-column mx-4 my-2">
                    <InputText
                      value={editAddressStateValue}
                      onChange={(e) =>
                        handleAddressStateEditChange(e.target.value)
                      }
                      id="firstName"
                      label="firstName"
                      placeholder="State"
                      className="w-full  bg-white-alpha-20 border-round-lg p-2 text-lg "
                    ></InputText>
                  </div>

                  <div className="flex flex-column mx-4 my-2">
                    <InputText
                      value={editAddressLandmarkValue}
                      onChange={(e) =>
                        handleAddressLandmarkEditChange(e.target.value)
                      }
                      id="firstName"
                      label="firstName"
                      placeholder="Landmark"
                      className="w-full  bg-white-alpha-20 border-round-lg p-2 text-lg "
                    ></InputText>
                  </div>

                  <div className="flex flex-column mx-4 my-2">
                    <InputText
                      value={editAddressPinValue}
                      onChange={(e) =>
                        handleAddressPinEditChange(e.target.value)
                      }
                      id="firstName"
                      label="firstName"
                      placeholder="Pin Code"
                      keyboardType="numeric"
                      maxLength={6} // Restrict input to 10 characters
                      className="w-full  bg-white-alpha-20 border-round-lg p-2 text-lg "
                    ></InputText>
                  </div>
                  {errors.editAddressPinValue && (
                    <div>
                      <p>{errors.editAddressPinValue}</p>
                    </div>
                  )}

                  <div>
                    <div className="flex mx-4 my-2">
                      <p className=" text-xl  font-semibold mr-3">
                        Default Address
                      </p>

                      <InputSwitch
                        checked={activeNotification}
                        onChange={(e) => setActiveNotification(e.value)}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>

            <Button
              onClick={handleEditData}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl  font-semibold flex justify-content-center">
                Submit
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
}
